import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider, SiteProvider } from "@/lib/store";
import StoreLayout from "@/components/store/Chrome";
import Home from "@/pages/Home";
import Catalogue from "@/pages/Catalogue";
import Product from "@/pages/Product";
import Basket from "@/pages/Basket";
import Checkout from "@/pages/Checkout";
import Pay from "@/pages/Pay";
import Track from "@/pages/Track";
import BlogList, { BlogPost } from "@/pages/Blog";
import { ContactPage, TermsPage } from "@/pages/Policy";
import OrderChoice from "@/pages/OrderChoice";
import Emails from "@/admin/Emails";

function RecordsRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/shop${search}`} replace />;
}
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import Orders from "@/admin/Orders";
import Stages from "@/admin/Stages";
import Products from "@/admin/Products";
import { StockPage, ImportPage, DeletePage, OrdersImportPage, GearStockPage, GearImportPage } from "@/admin/Sheets";
import Coupons from "@/admin/Coupons";
import Branding from "@/admin/Branding";
import Moods from "@/admin/Moods";
import HomeSections from "@/admin/HomeSections";
import MenuEditor from "@/admin/MenuEditor";
import Shipping from "@/admin/Shipping";
import Content from "@/admin/Content";
import BlogAdmin from "@/admin/BlogAdmin";

function App() {
  return (
    <SiteProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<StoreLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Catalogue />} />
              <Route path="/turntables-accessories" element={<Catalogue gear key="gear" />} />
              <Route path="/records" element={<RecordsRedirect />} />
              <Route path="/order-choice" element={<OrderChoice />} />
              <Route path="/record/:id" element={<Product />} />
              <Route path="/basket" element={<Basket />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/pay/:id" element={<Pay />} />
              <Route path="/track" element={<Track />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact-us" element={<ContactPage />} />
              <Route path="/terms-and-conditions" element={<TermsPage />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="orders" replace />} />
              <Route path="orders" element={<Orders />} />
              <Route path="stages" element={<Stages />} />
              <Route path="products" element={<Products />} />
              <Route path="stock" element={<StockPage />} />
              <Route path="import" element={<ImportPage />} />
              <Route path="delete" element={<DeletePage />} />
              <Route path="gear-stock" element={<GearStockPage />} />
              <Route path="gear-import" element={<GearImportPage />} />
              <Route path="coupons" element={<Coupons />} />
              <Route path="branding" element={<Branding />} />
              <Route path="moods" element={<Moods />} />
              <Route path="home" element={<HomeSections />} />
              <Route path="menu" element={<MenuEditor />} />
              <Route path="shipping" element={<Shipping />} />
              <Route path="content" element={<Content />} />
              <Route path="blog" element={<BlogAdmin />} />
              <Route path="emails" element={<Emails />} />
              <Route path="orders-import" element={<OrdersImportPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </CartProvider>
    </SiteProvider>
  );
}

export default App;
